import { getImageSrc } from 'utils';
import axios from 'axios';

const downloadPDF = async (pdfURL, fileName) => {
  const response = await axios({
    url: getImageSrc(pdfURL),
    method: 'GET',
    responseType: 'blob',
  });
  const pdfName = fileName ? fileName : 'report.pdf';
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', pdfName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const downloadBase64DataPDF = (base64Data = null, fileName) => {
  if (base64Data) {
    const pdfName = fileName ? fileName : 'report.pdf';
    const link = document.createElement('a');
    link.href = base64Data;
    link.setAttribute('download', pdfName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

export { downloadPDF, downloadBase64DataPDF };
